<template>
    <media-player v-if="current"
                  :media="current"
                  @show="onShow()"
                  @hide="onHide()"
    ></media-player>
</template>

<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                show: false,
            }
        },
        computed: {
            ...mapState({
                current: state => state.player.current,
            }),
        },
        created() {
            this.onRefresh()
        },
        mounted() {
            this.show = true
        },
        methods: {
            onRefresh() {
                this.show = false
                setTimeout(() => this.show = true, 200)
            },
            onShow() {
                this.$emit('show')
            },
            onHide() {
                this.$emit('hide')
            },
        },
        watch: {
            '$route': 'onRefresh'
        },
    }
</script>
